// Removed completely since in DLR we do have schema in slate

const ShortcutListing = (props) => {
  return <></>;
};

export default ShortcutListing;
